import { useOnline, useTranslation, ConditionalRender } from '@libs/core';
import React from 'react';
import { TranslationKeys } from '../types/enums';
import { CommonScreen } from './CommonScreen/CommonScreen';
import { WiFiIcon } from './Svg/WiFiIcon';

export const Offline = () => {
    const isOnline = useOnline();
    const { t } = useTranslation();

    return (
        <ConditionalRender condition={!isOnline}>
            <CommonScreen
                useIcon={true}
                Icon={WiFiIcon}
                headerText={t(TranslationKeys.ErrorNoConnectionText, 'No internet connection')}
                secondaryText={t(TranslationKeys.ErrorNoConnectionTextLine2, 'Check your internet connection and try again')}
                buttonLabel={t(TranslationKeys.ButtonRetry, 'Try again')}
            />
        </ConditionalRender>
    );
};
